<template>
  <!-- 购买企业套餐服务 -->
  <div class="buy-cps trademark-form">
    <div class="DgrayBg yregister">
      <div class="w1200 flow">
        <h2>选择商品配置</h2>
        <ul>
          <li>
            <i class="step">1</i>添加清单</li>
          <li>
            <i class="step">2</i>确认订单</li>
          <li>
            <i>3</i>在线支付</li>
          <li>
            <i>4</i>支付成功</li>
        </ul>
      </div>
    </div>

    <div class="grayBg yregister"
         style="padding:20px 0 40px;">
      <Order-panel titleName="选择注册版本">
        <div>
          <a href="javascript:;"
             v-for="item in domainPackageList">
            <input type="radio"
                   v-model="ruleForm.buyVersion"
                   class="label-rio"
                   name="label-btn"
                   :value="item.code"
                   :id="item.code">
            <label :for="item.code"
                   class="label-name">{{item.name}}</label>
          </a>

        </div>
      </Order-panel>
      <Order-panel titleName="提交商标注册信息">
        <div>
          <el-form :model="ruleForm"
                   :rules="rules"
                   ref="ruleForm"
                   label-width="100px"
                   class="demo-ruleForm">
            <el-form-item label="商标名称"
                          v-if="ruleForm.buyVersion !=2"
                          prop="productName">
              <div class="w500">
                <el-input v-model="ruleForm.productName"
                          placeholder="请输入商标名称"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="商标注册号"
                          v-else
                          prop="tradeMarkingNo">
              <div class="w500">
                <el-input v-model="ruleForm.tradeMarkingNo"
                          placeholder="请输入商标注册号"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="说明"
                          prop="remark">
              <div class="w500">
                <el-input type="textarea"
                          resize="none"
                          :rows="2"
                          maxlength="100"
                          show-word-limit
                          v-model="ruleForm.remark"
                          placeholder="请在此处对您要注册的商标做简短的描述说明，最多允许输入100个字符">
                </el-input>
              </div>

            </el-form-item>
            <el-form-item label="联系人称呼"
                          prop="contactName">
              <div class="w500">
                <el-input v-model="ruleForm.contactName"
                          placeholder="请输入联系人"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="联系人手机"
                          prop="mobilePhone">
              <div class="w500">
                <el-input placeholder="请填写联系人手机并完成验证"
                          v-model="ruleForm.mobilePhone">
                  <el-button slot="append"
                             @click="getValidateCode"
                             :disabled="disabledQuery">{{validateBtnWord}}</el-button>
                </el-input>
              </div>
              <!-- <div>
                <div class="w388 fl">
                  <el-input placeholder="请填写联系人手机并完成验证"
                            v-model="ruleForm.mobilePhone">
                  </el-input>
                </div>
                <el-button @click="getValidateCode"
                           type="primary"
                           :disabled="disabledQuery">{{validateBtnWord}}</el-button>
              </div> -->

            </el-form-item>
            <el-form-item label="验证码"
                          prop="code">
              <div class="w500">
                <el-input v-model="ruleForm.code"
                          placeholder="请输入短信验证码"></el-input>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="register-tip">
          <p class="f12 c6">商标注册说明：</p>
          <p class="f12 cb0">· 您填写商标注册申请信息后，我们会安排专业顾问在24小时内与您联系，若非工作时间内会在下一个工作日与您联系；</p>
          <p class="f12 cb0">· 中企动力会保护您的商标及个人信息，仅有指定的服务商能看到您的商标及联系方式，请您放心提供；</p>
          <p class="f12 cb0">· 商标服务商将会为您提供商标检索并提供成功率分析、拟定注册方案及报价以及商标提交。您可以在会员中心- 费用- 订单管理完成支付。</p>
          <p class="f12 c6">商标续展流程：</p>
          <p class="f12 cb0">· 商标续展费用：1500元/件；</p>
          <p class="f12 cb0">· 您填写申请信息后，我们会安排专业顾问在24小时内与您联系，若非工作时间内会在下一个工作日与您联系；</p>
          <p class="f12 cb0">· 专业顾问会使用区号为0592的座机与您联系，请放心接听，若您未能及时接听，专业顾问会再次与您联系；</p>
          <p class="f12 cb0">· 中企动力会保护您的商标及个人信息，仅有指定的服务商能看到您的商标及联系方式，请您放心提供；</p>
        </div>
        <div class="mt40">
          <input type="checkbox"
                 v-model="acceptAgreement"
                 id="agreement">
          <label for="agreement">我已阅读，理解并同意<a style="color:#108ee9;cursor:pointer;"
               @click="checkAgreement">《中企动力商标注册协议》</a></label>
        </div>
      </Order-panel>
      <div class="total">
        <button @click="$router.go(-1)">取消</button>
        <el-button :loading="nextButtonIsLoading"
                   style="padding:0;border-radius:0"
                   :class="{nextCur:acceptAgreement}"
                   @click="save">发送需求</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showacceptAgreement"
               width="50%">
      <div style="height: 500px;overflow-y:auto;">
        <p style="margin-bottom:5px;text-align:center">
          <strong><span style="font-size:24px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">商标服务条款</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">欢迎您使用中企平台选择商标相关服务，本平台下产品和服务由中企动力及其相应关联公司（下文简称“服务方”）向您提供。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">在您使用本服务前，请您务必仔细阅读本服务条款的全部内容，并在确认接受本服务条款后再进行后续操作。<strong>本服务条款将通过加粗或加下划线的形式提示您特别关注限制、免责条款以及管辖法院的选择条款等。</strong>如您不同意本服务协议或其中任何条款约定，您应不再进行下一步程序或放弃订单。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">本服务条款是服务方与用户（以下简称“您”）之间，就您为您本人及/或您所代表的商标注册申请人之间，通过中企平台提供的在线商标服务（以下简称“本服务”），进行商标注册、续展等相关事宜所订立的有效合约。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:28px">
          <span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">当您提交商标注册、续展等相关申请，应同意接受本服务条款并平台规则及提示遵守内容时，或您通过线下签署书面协议、实际使用服务、或服务方认可且符合法律法规惯例的其他任一方式确认本服务条款后，即表示您与服务方已就本服务条款的内容达成一致意见。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">您继续后续操作的行为，将被视为您已完全接受本服务条款的全部约定，本服务条款对服务方和您均具有法律约束力。</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">定义及解释</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.1</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方：</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">即中企动力及其相应关联公司服务方将为您的商标注册/续展事项提供平台服务与技术支持。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.2</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户(您)：</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">是指通过服务方提供的商标服务平台，为本人或其授权委托人进行商标注册、续展等相关申请活动的会员用户，包括个人（自然人、个人独资企业、个人合伙和个体工商户等）或者组织（国家机关、公司、合伙企业、事业单位、社会团体和其他组织等）。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.3</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">商标服务：</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">是指一系列通过服务方在线平台申请或提供的商标服务及增值服务。服务方有权根据业务策略适时调整平台商标服务的内容。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.4</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">商标申请人：</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">是指向商标管理部门提出商标注册、续展等相关申请的主体。包括依法成立的企业、事业单位、社会团体、个体工商户、个人合伙以及符合《商标法》规定的外国人或者外国企业。商标申请人可能是用户本人，也可能是委托用户代为提交申请的其他人。<strong>当商标申请人并非用户本人时，用户须取得并提交商标申请人的正式授权并提交证明文件后 ，方可使用服务方平台为商标申请人提交相关商标申请。</strong></span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.5</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">第三方服务：</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方平台提供的商标服务为第三方服务商的商标代理服务，本服务中的部分服务（例如：专家辅助申请服务、担保注册、商标续展申请服务等），将由第三方系统或第三方服务商为用户提供，服务方明确告知用户该等服务由第三方服务商提供，用户使用该等服务，意味着用户知悉并同意应当遵守与第三方服务商另行达成的服务协议的条款约定。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.6</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">本服务条款中的<strong>“商标”</strong>仅指中华人民共和国大陆地区的商标，不包括港澳台地区及海外。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">1.7</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方服务过程中所涉及的本服务所有名词术语，例如：商标注册、驳回复审、异议答辩、商标续证、优先权等，均以《中华人民共和国商标法》及商标法律法规、商标行政管理部门的相关定义及解释为准。<ins datetime="2019-07-04T14:14"></ins></span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;Tahoma&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.&nbsp;&nbsp;&nbsp;&nbsp;</span></strong><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务内容</span></strong>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.1&nbsp; &nbsp;&nbsp;</span></strong><strong><span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务范围</span></strong>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.1.1&nbsp; &nbsp; </span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方所称的商标服务主要包括：商标注册</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:48px;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.1.1.1&nbsp; &nbsp; </span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">为商标注册服务提供所需的相应平台、通道、体系，以及与之相关的技术支持、售前售后咨询等服务。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.1.1.2 &nbsp; </span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">其他与商标服务相关的增值服务等。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;text-align:left;text-indent:24px">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.1.2&nbsp; &nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方有权根据业务策略适时调整服务的范围与内容，具体以用户使用服务当时服务方相关页面的展示为准。</span></strong>
        </p>
        <p style="margin-top:16px;margin-bottom: auto;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.2&nbsp; &nbsp;&nbsp;</span></strong><strong><span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务开始<br /> </span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户理解并确认，在用户使用本服务前已完全清楚以下要求及事项：<br /> 2.2.1&nbsp; &nbsp;&nbsp;对于免费服务，服务方在收到用户提交的有效申请及/或确认后，才开始提供服务。例如：对于需要手机验证等方式确认用户所提交申请真实性的，服务方在用户完成验证后，才开始处理用户的请求。<strong><br /> </strong>2.2.2&nbsp; &nbsp;&nbsp;对于收费服务，服务方在收到用户提交的有效申请及/或确认，并且完成所有费用的缴纳后，才开始提供服务。即服务方在收到用户缴纳的费用后，才会开始处理用户申请的相关服务。<strong>因此，订单支付成功并不代表相关商标的注册、续展等申请已经提交第三方服务商或商标管理部门。 </strong></span>
        </p>
        <p style="margin-top:16px;margin-bottom: auto;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.3&nbsp; &nbsp;&nbsp;</span></strong><strong><span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务结果<br /> 2.3.1&nbsp; &nbsp;&nbsp;用户理解并同意，用户通过服务方提交的商标注册、续展等申请是否成功取决于商标标志本身及申请时间等因素，并经商标局依法审查后决定。服务方仅代为提交有关手续，除双方另有明确书面约定外，不以任何明示或者暗示的方式担保用户提交的商标注册申请或其他申请能够成功。<br /> </span></strong><span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.3.2&nbsp; &nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方有权对用户提交的商标申请材料进行初步审核，如果认为内容不合法或材料不符合要求，服务方会要求用户修改或补充材料。<strong>自用户完成费用支付之日起满30天时，如用户提交的材料仍不能符合提交商标局的要求，服务方有权终止本次商标服务，并将收取的相关费用退还给用户。如用户还需要继续申请注册或续展商标，需要重新购买服务。<br /> </strong>2.3.3&nbsp; &nbsp;&nbsp;<strong>服务方提供的商标服务均为单次服务</strong>。<strong>例如：如果用户对商标局驳回决定不服的，选择提起驳回复审；或者在用户的商标初审公告之日起3个月内被异议后，选择提出异议答辩的；或者用户需要对已注册的商标改变其标志的，用户均应另行购买相应的服务方申请服务，重新提交申请并另行付费。</strong></span>
        </p>
        <p style="margin-top:16px;margin-bottom: auto;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.4&nbsp; &nbsp;&nbsp;</span></strong><strong><span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">商标注册服务<br /> </span></strong><span style=";font-family: &#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.4.1&nbsp; &nbsp; </span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户可以在通过服务方或关联公司平台选择购买 “商标担保版”、“商标顾问版”两种类型的商标注册服务。<br /> 2.4.2&nbsp; &nbsp; 服务方不会对用户的商标注册申请是否侵犯他人在先权利，或他人拟申请注册的商标是否侵犯用户的在先权利等进行审核，用户自行承担责任。<br /> 2.4.3&nbsp; &nbsp; 在用户提交的商标注册申请尚未提交至商标局前，用户可以选择申请退款，终止本次申请的商标服务。<strong>商标注册申请提交至商标局后，不论商标是否注册成功，已收取的费用都不予退还。</strong>商标注册申请是否提交至商标局，以服务方/第三方服务商后台数据为准。</span>
        </p>
        <p style="margin-top:16px;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">2.4.4&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">在购买“商标担保版”后，商标注册被全部驳回，视为担保失败，可以全额退款。“部分驳回”或者有“项目初审公告”，则视 为担保成功，不予退款。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务费用</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.1</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户理解并同意，服务方将根据用户选择的商标服务的类型和数量收取对应的服务费用，服务费用的收取方式为系统自动结算。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.2</span></strong><strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;</span></strong><strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:red">&nbsp;&nbsp;</span></strong><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:red">服务方将在网站（www.300.cn）</span></strong><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">的相关网页/平台公示有关收费标准和缴费要求，并有权根据业务需要和市场变化等原因，调整上述标准和要求；或者根据当时的市场状况及自身经营政策等因素，制定不同的服务收费标准、优惠与促销政策等。本服务协议约定相关服务价格及退款规则等条款内容与上述服务方平台公告不一致的，以服务方平台/网页公告内容为准。</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.3</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">若用户对服务方提供的收费标准、费用结算事项的通知内容有异议，应及时以书面形式告知服务方，并停止使用本服务；否则，视为用户认可服务方提供的费用结算事项的通知内容，双方应按照服务方提供的费用结算事项的通知内容，进行费用的结算及支付等。</span></strong>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.4</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方会定期或不定期推出优惠活动或政策。用户理解并确认：</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.4.1</span><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">此类优惠活动或政策均为服务方在正常服务价格之外的特别优惠；服务方不保证用户一定可以享受该等特别优惠。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.4.2</span><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户在通过参与优惠活动或享受优惠政策而购买了服务方商标服务后，又在规定的退订时间内进行服务退订的，则服务方有权采取恢复原价计费、收取违约金或收取退订/退款手续费、补偿免费代金券抵扣金额等方式进行处理，具体以服务方在相应页面、订单或活动规则中载明的方式为准。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.4.3</span><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">除非服务方以书面形式给予明确说明，通常情况下，多种优惠不可同时叠加适用。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.5</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户理解并认可，服务方可能在一定期间或一定使用额度内为用户提供优惠活动：</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.5.1</span><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp; &nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">在优惠活动期间内，用户可享受一定额度的服务费用的折扣优惠。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.5.2</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp; &nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方并不排除日后取消该等优惠服务活动的可能，届时服务方将提前10个自然日通过在网站内合适版面发布公告或发送站内通知等方式公布收费政策及规范；</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.5.3</span><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">如用户仍使用相应服务的，用户应按届时最新的收费政策付费。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">3.5.4&nbsp; &nbsp;</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户同意，因收费标准调整等产生的任何纠纷，除法律有明确规定外，服务方有免于诉讼或仲裁的权利。</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户行为准则</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.1</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户在确认本服务条款并使用商标注册服务前，应保证：</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.1.1</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户已认真阅读并充分理解本服务条款的所有内容及服务方在平台相关页面公布的商标服务规则；用户应当遵守本服务条款及服务方商标服务规则的所有已公示并生效的规定，不能以未仔细阅读规则或规则理解偏差为由，作为用户不遵守规则、违约的理由。</span></strong>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.1.2</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">如用户是代表第三方注册，用户应确保已获得该第三方的全部合法授权，且该第三方已理解并同意遵守前述所有义务。此外，如果用户提供的注册信息及资料中包括第三方的信息及使用，用户应确保已经告知并获得该第三方的同意。</span></strong>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.1.3</span><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">如果用户在未取得商标注册证之前已经使用该未注册商标，用户应注意在广告、产品等方面的适量投入，且不得随意更改商标样式；否则有可能会影响用户的商标注册申请成功率。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.2</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户应了解并保证：</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.2.1</span><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户所提交的商标申请信息及材料应当真实、准确、完整、合法<strong>，若因提交的信息或材料不准确而影响商标申请及商标注册后的权利使用，用户需自行承担责任及后果</strong>。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:48px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.2.2</span></strong><strong><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户在提交相关商标申请时应提供完整，准确，可靠的联系人详细信息，且该等信息在商标申请审核期间如有变更的，用户应及时予以更正和更新<strong>。如因联系方式提供错误或未更新导致信息传达延误，用户需自行承担责任及后果。</strong></span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:48px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.2.3</span></strong><strong><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户应积极配合，对于商标局要求在规定时间内给予反馈的通知文件，用户应在规定时间内反馈意见或提交所需材料。<strong>如因用户未及时反馈信息或提供所需材料，用户需自行承担责任及后果。</strong></span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:48px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.2.4</span></strong><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">如果用户并非为本人提交申请，而是接受商标申请人的委托，代为提交相关商标申请的，除符合规范的申请文件外，还应当提交商标申请人的相关主体资格证明、委托授权书等相关材料；如申请过程中商标申请人的名称、地址发生变化的，用户应及时更新委托文件，以免影响商标申请的受理及申请信息的准确及正确。</span></strong>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.3</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户应了解并保证，</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:48px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.3.1</span></strong><strong><span style="font-size:10px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp; &nbsp;&nbsp;</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户提交相关商标申请的请求内容及相关申请材料，均不会侵害任意第三方的权益，亦不存在违法违规情形，用户的商标申请不是为了恶意或任何非法目的。<strong>如有故意抢注或刻意模仿他人商标或其他侵犯他人知识产权的行为，用户需自行承担责任及后果。</strong></span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:48px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">4.3.2&nbsp; &nbsp;</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">如用户因申请或使用此商标而引起的任何纠纷或损失，与服务方无关。同时，用户有义务保护服务方免于受到任何因用户申请或使用此商标而引起的第三方诉讼、索赔或其他行为而造成的损害。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:48px;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">5.</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方服务承诺</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">5.1</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方在接受用户的委托，代理用户向商标局申请相关商标事项后，将在用户的委托事项和委托范围内开展工作，不会随意更改商标代理事项。用户应按照要求向服务商提供合法有效明确的授权等。</span>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">5.2</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方在用户提交符合要求的全部文件资料后，服务方将及时向第三方服务商或商标局提交用户的商标申请。但如果服务方进行初步审核后，认为用户的申请内容不合法或申请材料不符合要求的，服务方有权要求用户修改或补正材料。在用户未按要求进行修改或补正前，服务方不会向商标局提交用户的商标申请并不承担任何责任。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">5.3</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;<strong>&nbsp;</strong></span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">如用户特别授权服务方代收相关文件资料的，服务方将会在收到商标局的相关文件后15个工作日内，将原件寄至用户在服务方平台系统中预留的收件地址，请用户再次确认在服务平台中的收件地址是正确的、有效的地址，因用户收件地址填写错误，造成用户未收到相关文件的后果由用户自行承担，与服务方无关</span></strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">5.4</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">服务方将采取安全保密措施保护用户提交的商标申请信息及材料。对于在服务过程中涉及用户及/或商标申请人的商业信息、知识产权信息或个人信息，未经用户同意，服务方不会泄露给与本服务无关的任何第三方，不得用于本合同外的目的。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">6.</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">不可抗力及责任承担</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">6.1</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">因不可抗力或者其他意外事件，使得本服务履行不可能、不必要或者无意义的，遭受不可抗力、意外事件的一方不承担责任。“不可抗力、意外事件”是指不能预见、不能克服并不能避免且对一方或双方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行等以及社会事件如战争、动乱、政府行为、电信主干线路中断等。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">6.2</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">鉴于互联网的特殊性，黑客攻击<strong>、互联网连通中断或者系统故障、电信部门原因造成的连通中断等非服务方原因给用户造成的损失，除另有生效法律文书规定外，服务方不承担责任。</strong></span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">6.3</span></strong><strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span></strong><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">若因服务方的过错导致用户商标申请失败，服务方的责任上限为该笔申请费用。服务方不对用户的其他直接或间接损失、商机的消失、利润的损失、侵权、其他无形损失及基于用户与他人签署的合同而遭受的损失承担责任。</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">6.4</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户应承担违反本服务条款而给服务方造成的损失。服务方未对违约采取措施不能成为用户违约或者抗辩的理由和解释。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">6.5</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">本服务条款对责任承担另有规定的，从其规定。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">7.</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">适用法律与争议解决</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">7.1</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">本服务条款的订立、执行和解释及争议的解决均应适用中华人民共和国法律。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">7.2</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户理解并同意，用户与服务方之间就服务方为用户提供的商标的服务而引发争议时，<strong>双方当事人应通过友好协商方式解决。</strong></span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">如果协商未成，双方同意向服务方主要经营地的有管辖权的人民法院提起诉讼。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:32px">
          <span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">8.</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">其他</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">8.1</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">本服务条款如果与双方以前签署的有关条款或者服务方的有关陈述不一致或者相抵触的，以本服务条款为准。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:24px;text-align:left">
          <strong><span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">8.2</span></strong><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;</span><strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">用户与服务方就商标服务达成的服务协议，除以上服务条款主文以外，还应包括服务方在相关页面上的服务说明、价格说明、操作文档和用户确认同意的订购页面、订单信息等，该等内容均为本服务条款不可分割的一部分。此外，服务方将来可能发布并采取合理途径通知的、与本服务相关各类规则，亦为本服务条款的一部分，具有同等法律效力。鉴于网络协议的特殊展现形式，以上内容共同构成完整有效的合同文件，对服务方与用户均具有法律约束力。</span></strong>
        </p>
        <p style="margin-top:auto;margin-bottom: auto;margin-left:24px;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">8.3</span><span style="font-size:9px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">本服务条款项下之保证条款、保密条款、知识产权条款、法律适用及争议解决条款等内容，不因服务的终止而失效。</span>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left;text-indent:28px">
          <strong><span style=";font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">您在此再次保证，已经完全阅读并理解了上述商标服务条款并自愿正式进入商标注册服务流程，接受上述条款的约束。</span></strong>
        </p>
        <p style="margin-top:5px;margin-right:0;margin-bottom:5px;margin-left:0;text-align:left">
          <span style="font-size:12px;font-family:&#39;微软雅黑&#39;,&#39;sans-serif&#39;;color:#333333">&nbsp;</span>
        </p>
        <p>
          <br />
        </p>
      </div>
      <!-- <span slot="footer"
            class="dialog-footer">
        <el-button @click="acceptAgreement = false">取 消</el-button>
        <el-button type="primary"
                   @click="acceptAgreement = false">确 定</el-button>
      </span> -->
    </el-dialog>
    <!-- 隐藏埋点说明 start -->
    <!--需要埋点的表单以下隐藏字段为必须，class名一定不要错,需要引入pulic.js(即埋点所在js),相应的值会自动加入  -->
    <input type="hidden"
           class="log_id"
           name="log_id"
           value="" />
    <input type="hidden"
           class="promoteSlug"
           name="promoteSlug"
           value="" /> <!-- 常规表单不记入活动 -->
    <input type="hidden"
           class="channelSlug"
           name="channelSlug"
           value="" />
    <input type="hidden"
           class="formSlug"
           name="formSlug"
           value="" />
    <input type="hidden"
           class="landUrl"
           name="landUrl"
           value="" />
    <input type="hidden"
           class="sourceUrl"
           name="sourceUrl"
           value="" />

    <!-- 以下两个需要后台设置，设置说明有单独的文档-->
    <input type="hidden"
           name="eventType"
           value="ywpt-sbzc" /> <!-- 打开表单按钮  后台设置-->
    <input type="hidden"
           name="formType"
           value="业务品台商标注册" /> <!-- 打开表单按钮  后台设置-->
    <!--线索类型 后台设置 无特殊情况 为 INTENTION_SOURCE_300 或可不填 -->
    <input type="hidden"
           name="baiduSource"
           value="brandreg" />
    <!-- 隐藏埋点说明  end-->

  </div>
</template>
<script>
import cTitle from './components/title'
import OrderPanel from './components/confirm-order-panel'

export default {
  data () {

    var validatePass2 = (rule, value, callback) => {
      let regxMobile = /^1\d{10}$/ig
      if (value === '') {
        callback(new Error('请输入联系人手机'))
      } else if (!regxMobile.test(value)) {
        callback(new Error('请输入11位的手机号码!'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        productName: '',
        tradeMarkingNo: '',
        buyVersion: '1',
        remark: '',
        contactName: '',
        mobilePhone: '',
        code: ''
      },

      rules: {
        productName: [
          { required: true, max: 30, message: '最多允许输入30个字符', trigger: 'blur' },],
        tradeMarkingNo: [
          { required: true, max: 30, message: '最多允许输入30个字符', trigger: 'blur' },],
        buyVersion: [{
          required: true,
        }],
        remark: [{
          max: 200,
          message: '请在此处对您要注册的商标做简短的描述说明，最多允许输入100个字符'
        }],
        contactName: [
          {
            required: true,
            message: '请输入联系人信息'
          },
          {
            min: 2, max: 20, message: '请输入2~20个字符'
          }],
        mobilePhone: [{
          required: true,
          validator: validatePass2,
        }, {

        }],
        code: [{
          required: true,
          message: '请输入短信验证码'
        }]
      },
      disabledQuery: false,
      nextButtonIsLoading: false,
      acceptAgreement: false,
      buyVersion: 'jzbb',
      domainPackageList: {
        jzbb: {
          code: '0',
          price: '336.00',
          suffix: '.com、.cn、.net',
          promotionId: '44d02891869c11e9874f005056837eb8',
          promotionName: '域名_建站必备后缀套餐',
          name: '专家辅导版',
          placeHolder: '建站必备域名含 .com、.cn、.net 三款后缀'
        },
        qypp: {
          code: '1',
          price: '2240.00',
          promotionId: '0ff3e59b869d11e9874f005056837eb8',
          promotionName: '域名_企业品牌保护套餐',
          suffix: '.网址、.中国、.企业',
          name: '担保注册版',
          placeHolder: '企业品牌保护含 .网址、.中国、.企业 三款后缀'
        },
        sbxz: {
          code: '2',
          price: '1500.00',
          promotionId: '0ff3e59b869d11e9874f005056837eb8',
          promotionName: '域名_企业品牌保护套餐',
          suffix: '.网址、.中国、.企业',
          name: '商标续展',
          placeHolder: '企业品牌保护含 .网址、.中国、.企业 三款后缀'
        }
      },
      showacceptAgreement: false,
      isSuccess: true,
      intervalNum: 60,
      validateBtnWord: '获取验证码'
    }
  },
  components: {
    cTitle,
    OrderPanel

  },
  created () {
    this.ruleForm.buyVersion = this.$route.query.code
    //强制验证登录
    this.checkLogin()
  },
  methods: {
    checkLogin () {
      if (
        window.__PRERENDER_INJECTED &&
        window.__PRERENDER_INJECTED.prerender === 'trademark'
      ) {
        return
      }

      $.get(
        `${__shopURL}/orders/checklogin?backurl=${window.location.href}`
      ).then(response => {

      })
    },
    checkAgreement () {
      this.showacceptAgreement = true
    },
    getValidateCode () {
      this.$refs.ruleForm.validateField('mobilePhone', (mobilePhone) => {
        if (!mobilePhone) {
          this.intervalNum = 60
          this.disabledQuery = true
          let interval = setInterval(() => {
            if (this.intervalNum < 0) {
              this.validateBtnWord = '获取验证码'
              this.disabledQuery = false
              clearInterval(interval)
              this.intervalNum = 60
            } else {

              this.validateBtnWord = `${this.intervalNum}秒后重新获取`
              this.intervalNum = this.intervalNum - 1
            }
          }, 1000)

          $.get(
            `${__shopURL}/security/shop/getSmsCode?mobileCode=${
            this.ruleForm.mobilePhone
            }`
          ).then(response => {
            if (response && response.status != 101) {
              this.$message.error(response.msg)
              clearInterval(interval)
              return
            }

          })
        }
      })

    },
    save () {
      // if (
      //   window.__PRERENDER_INJECTED &&
      //   window.__PRERENDER_INJECTED.prerender === 'domain'
      // ) {
      //   return
      // }
      if (!this.acceptAgreement) {
        this.$msgbox({
          // title:'',
          type: 'error',
          message: '请先同意《中企动力商标注册服务协议》'
        })
        return
      }
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.nextButtonIsLoading = true
          if (this.ruleForm.buyVersion != 2) {
            delete this.ruleForm.tradeMarkingNo
          } else {
            delete this.ruleForm.productName
          }
          $.get(`${__shopURL}/security/shop/save`, this.ruleForm).then(response => {
            this.nextButtonIsLoading = false
            if (response && response.status != 101) {
              this.$message.error(response.msg)
              return
            }
            this.$router.push({
              path: '/trademark/trademark-success',
              query: {
                buyVersion: this.ruleForm.buyVersion
              }
            })
            this.isSuccess = true
          })

        }
      })
    },
    // sendData () {
    //   let sendDataObj = {}
    //   sendDataObj.log_id = $(".log_id").val()
    //   sendDataObj.promoteSlug = $(".promoteSlug").val()
    //   sendDataObj.channelSlug = $(".channelSlug").val()
    //   sendDataObj.formSlug = $(".formSlug").val()
    //   sendDataObj.landUrl = $(".landUrl").val()
    //   sendDataObj.sourceUrl = $(".sourceUrl").val()
    //   sendDataObj.eventType = $("[name='eventType']").val()
    //   sendDataObj.formType = $("[name='formType']").val()
    //   sendDataObj.baiduSource = $("[name='baiduSource']").val()

    //   sendDataObj.mobile = this.ruleForm.mobilePhone
    //   sendDataObj.truename = this.ruleForm.contactName
    //   sendDataObj.email = ''
    //   sendDataObj.province = ''
    //   sendDataObj.city = ''
    //   if (this.ruleForm.buyVersion != 2) {
    //     sendDataObj.remark = `商标名称：${this.ruleForm.productName},说明：${this.ruleForm.remark},注册版本：${this.ruleForm.buyVersion == 1 ? '担保注册版' : '专家辅导版'}`
    //   } else {
    //     sendDataObj.remark = `商标注册号：${this.ruleForm.tradeMarkingNo},说明：${this.ruleForm.remark},注册版本：商标续展`
    //   }


    //   $.get(`${window.location.origin}/customer/clue?tuijian_yzm=1&is_ajax=1`, sendDataObj).then(response => {
    //   })
    // }
  }
}
</script>

<style lang="scss">
.w500 {
  width: 500px;
}
.cb0 {
  color: #b0b0b0;
}
.c6 {
  color: #666;
}
.trademark-form {
  .w388 {
    width: 388px;
  }
  .w358 {
    width: 358px;
  }
  .register-tip {
    padding: 20px;
    background: #f9f9f9;

    p {
      line-height: 24px;
    }
  }
  .el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    color: #c0c4cc;
    background-image: none;
    background-color: #fff;
    border-color: #ebeef5;
  }
}
@import "../static/css/buy-cps.scss";
@import "../static/css/register.scss";
</style>



// WEBPACK FOOTER //
// src/trademarkform.vue